'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _FilterFilled = _interopRequireDefault(require('./lib/icons/FilterFilled'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _FilterFilled;
exports.default = _default;
module.exports = _default;